import { styled, Tabs, Theme } from '@mui/material';
import { CoreTypography } from '@youscience/core';

import { Container } from '@components/Layout/components/Container';

// TODO add color to library
const pageBg = '#F9F9F9';

export const sxStyles = {
  pageBg: {
    backgroundColor: pageBg,
  },
  headSectionWrap: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  navBarInfo: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '668px',
    color: theme.palette.common.black,
  }),
};

export const StyledNavBar = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginBottom: '2rem',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

export const StyledNavBarTitle = styled(CoreTypography)(({ theme }) => ({
  marginTop: '1rem',
  marginBottom: '1.5rem',

  [theme.breakpoints.up('xs')]: {
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
  },
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: '4rem',

  button: {
    padding: '0.5rem',
  },

  [theme.breakpoints.up('md')]: {
    marginBottom: 0,
  },

  [theme.breakpoints.up('xs')]: {
    button: {
      marginRight: '1rem',
      padding: '1rem',
    },
  },
}));

export const StyledContentSection = styled(Container)(({ theme }) => ({
  marginTop: 0,

  [theme.breakpoints.up('md')]: {
    marginTop: '1.25rem',
  },
}));
